/**
 * Component: NotFoundPage
 * SpecReferenceID: FRONTEND-WEB-V1
 * Requirements: FRONTEND-WEB-V1-R01, FRONTEND-WEB-V1-R14
 *
 * 404 error page with accessible navigation options.
 * Accessibility: WCAG 2.1 AA compliant
 */

import React from 'react';
import { Link } from 'react-router-dom';

export function NotFoundPage(): React.ReactElement {
  return (
    <div className="mx-auto max-w-md text-center">
      <h2 className="mb-4 text-4xl font-bold">404</h2>
      <p className="mb-8 text-lg text-muted-foreground">Page not found</p>
      <p className="mb-8 text-foreground">
        The page you are looking for does not exist or has been moved.
      </p>
      <Link
        to="/"
        className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 focus-ring"
      >
        Return to Home
      </Link>
    </div>
  );
}
